<template>
	<auth-layout
		headline="重置您的密码"
		subtext="验证身份后重新设置密码。"
		mobile-desc="找回密码"
		:badges="[
			{ label: '安全', text: '短信验证码验证身份，防止未授权操作' },
			{ label: '快速', text: '四步完成密码重置，简单高效' }
		]"
	>
		<template #preview>
			<div class="preview-card">
				<div class="preview-step">
					<div class="preview-step-num">1</div>
					<div class="preview-step-body">
						<div class="preview-step-label">输入手机号</div>
						<div class="preview-step-desc">验证账号归属</div>
					</div>
					<i class="el-icon-check preview-step-done"></i>
				</div>
				<div class="preview-step">
					<div class="preview-step-num">2</div>
					<div class="preview-step-body">
						<div class="preview-step-label">短信验证码</div>
						<div class="preview-step-desc">确认身份安全</div>
					</div>
					<i class="el-icon-check preview-step-done"></i>
				</div>
				<div class="preview-step preview-step--active">
					<div class="preview-step-num preview-step-num--active">3</div>
					<div class="preview-step-body">
						<div class="preview-step-label">设置新密码</div>
						<div class="preview-step-desc">进行中...</div>
					</div>
				</div>
				<div class="preview-step preview-step--pending">
					<div class="preview-step-num preview-step-num--pending">4</div>
					<div class="preview-step-body">
						<div class="preview-step-label">完成重置</div>
						<div class="preview-step-desc">即将完成</div>
					</div>
				</div>
				<div class="preview-status">
					<i class="el-icon-lock"></i> 全程加密，安全可靠
				</div>
			</div>
		</template>

		<!-- 重置密码卡片 -->
		<div class="auth-card">
			<div class="card-header">
				<div class="card-title">重置密码</div>
				<div class="card-desc">验证身份后设置新密码</div>
			</div>
			<div class="card-content">
				<!-- 步骤1: 验证身份 -->
				<div v-if="!verified">
					<div class="form-group">
						<label class="form-label">手机号码</label>
						<el-input
							v-model="dataForm.phone"
							placeholder="请输入7-15位国际手机号"
							maxlength="16"
							prefix-icon="el-icon-mobile-phone"
						></el-input>
					</div>
					<div class="form-group">
						<label class="form-label">短信验证码</label>
						<div class="code-input">
							<el-input
								v-model="dataForm.code"
								placeholder="请输入6位短信验证码"
								prefix-icon="el-icon-message"
							></el-input>
							<el-button class="send-code-btn" type="primary" plain :disabled="phoneLockTime > 0"
								@click="onSendSmsCode">
								{{ phoneLockTime > 0 ? `${phoneLockTime}s` : '获取验证码' }}
							</el-button>
						</div>
					</div>
					<el-button class="submit-btn" type="primary" :disabled="!canVerify" @click="onVertifyCode()">验证身份</el-button>
				</div>

				<!-- 步骤2: 设置新密码 -->
				<div v-else-if="!resetDone">
					<div class="verified-hint">
						<i class="el-icon-success"></i>
						<span>身份验证通过，请设置新密码</span>
					</div>
					<div class="form-group">
						<label class="form-label">新密码</label>
						<el-input v-model="dataForm.password" type="password" placeholder="请输入5-20位字母或数字新密码"
							prefix-icon="el-icon-lock" show-password></el-input>
					</div>
					<div class="form-group">
						<label class="form-label">确认新密码</label>
						<el-input v-model="dataForm.confirmPassword" type="password" placeholder="请再次输入5-20位字母或数字新密码"
							prefix-icon="el-icon-lock" show-password></el-input>
					</div>
					<el-button class="submit-btn" type="primary" :disabled="!canSubmit" @click="onSubmit">重置密码</el-button>
				</div>

				<!-- 步骤3: 完成 -->
				<div v-else class="success-content">
					<i class="el-icon-success success-icon"></i>
					<h3>密码重置成功</h3>
					<p>{{ countdown }} 秒后自动跳转到登录页面</p>
					<el-button type="primary" @click="toLogin">立即登录</el-button>
				</div>

				<div class="card-footer">
					<router-link to="/login">返回登录</router-link>
				</div>
			</div>
		</div>

		<template #extra>
			<captcha-image ref="captchaRef" dialog-width="360px" image-max-width="220px"></captcha-image>
		</template>
	</auth-layout>
</template>

<script>
import AuthLayout from '../components/common/AuthLayout.vue';
import CaptchaImage from '../components/common/CaptchaImage.vue';
import { syncAuthWindow } from '../utils/authWindow';
import { isPhoneValid, trimOuterWhitespace } from '../utils/authValidators';

export default {
	components: {
		AuthLayout,
		CaptchaImage
	},
	data() {
		return {
			verified: false,
			resetDone: false,
			phoneLockTime: 0,
			phoneLockTimer: null,
			countdown: 0,
			countdownTimer: null,
			dataForm: {
				mode: 'phone',
				phone: '',
				code: '',
				password: '',
				confirmPassword: '',
			}
		};
	},
	methods: {
		normalizeResetForm() {
			this.dataForm.phone = trimOuterWhitespace(this.dataForm.phone);
			this.dataForm.code = trimOuterWhitespace(this.dataForm.code);
			this.dataForm.password = trimOuterWhitespace(this.dataForm.password);
			this.dataForm.confirmPassword = trimOuterWhitespace(this.dataForm.confirmPassword);
		},
		onSendSmsCode() {
			this.normalizeResetForm();
			if (!isPhoneValid(this.dataForm.phone)) {
				this.$message.error('请输入7-15位国际手机号');
				return;
			}
			this.$refs.captchaRef.open((id, code) => {
				this.phoneLockTime = 60;
				this.phoneLockTimer && clearInterval(this.phoneLockTimer);
				this.phoneLockTimer = setInterval(() => {
					this.phoneLockTime -= 1;
					if (this.phoneLockTime <= 0) {
						this.phoneLockTimer && clearInterval(this.phoneLockTimer);
					}
				}, 1000)
				let data = {
					phone: this.dataForm.phone,
					id: id,
					code: code
				}
				this.$http({
					url: "/captcha/sms/code",
					method: 'post',
					data: data
				}).then(() => {
					this.$message.success("验证码已发送至您的手机，请注意查收")
				})
			});
		},
		onVertifyCode() {
			this.normalizeResetForm();
			this.$http({
				url: '/captcha/sms/vertify',
				method: 'post',
				data: {
					id: this.dataForm.phone,
					code: this.dataForm.code
				}
			}).then(isPass => {
				if (!isPass) {
					this.$message.error("验证失败,请重新输入验证码")
					this.dataForm.code = "";
				} else {
					this.verified = true;
				}
			})
		},
		onSubmit() {
			this.normalizeResetForm();
			if (this.dataForm.confirmPassword != this.dataForm.password) {
				this.$message.error("两次密码输入不一致")
				return;
			}
			this.$http({
				url: '/resetPwd',
				data: this.dataForm,
				method: 'PUT'
			}).then(() => {
				this.$message.success('密码重置成功！');
				this.dataForm.code = '';
				this.dataForm.password = '';
				this.dataForm.confirmPassword = '';
				this.resetDone = true;
				this.startCountdown();
			})
		},
		startCountdown() {
			this.countdown = 5;
			this.countdownTimer = setInterval(() => {
				if (this.countdown > 0) {
					this.countdown--;
				} else {
					clearInterval(this.countdownTimer);
					this.toLogin();
				}
			}, 1000);
		},
		toLogin() {
			this.$router.push("/login");
		}
	},
	computed: {
		canVerify() {
			return this.dataForm.phone && this.dataForm.code;
		},
		canSubmit() {
			return this.dataForm.password && this.dataForm.confirmPassword;
		},
		containsPhoneMode() {
			return this.modes.includes("phone")
		},
		modes() {
			return (this.configStore.globalConfig?.registration?.mode || []).filter((item) => item !== 'email')
		}
	},
	mounted() {
		this.configStore.loadConfig().catch((error) => {
			console.error('加载系统配置失败:', error);
		});
		syncAuthWindow();
	},
	watch: {
		'dataForm.phone'(value) {
			const normalized = trimOuterWhitespace(value);
			if (normalized !== value) {
				this.dataForm.phone = normalized;
			}
		},
		'dataForm.code'(value) {
			const normalized = trimOuterWhitespace(value);
			if (normalized !== value) {
				this.dataForm.code = normalized;
			}
		},
		'dataForm.password'(value) {
			const normalized = trimOuterWhitespace(value);
			if (normalized !== value) {
				this.dataForm.password = normalized;
			}
		},
		'dataForm.confirmPassword'(value) {
			const normalized = trimOuterWhitespace(value);
			if (normalized !== value) {
				this.dataForm.confirmPassword = normalized;
			}
		}
	}
}
</script>

<style scoped lang="scss">
@import "../assets/style/auth-card";
@import "../assets/style/auth-preview";

.form-group {
	margin-bottom: 10px;
}

.code-input {
	display: flex;
	gap: 6px;

	.el-input { flex: 1; }

	.send-code-btn {
		height: 40px;
		border-radius: 10px;
		padding: 0 14px;
		white-space: nowrap;
	}
}

.verified-hint {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	margin-bottom: 12px;
	border-radius: 10px;
	background: rgba(var(--im-success-rgb, 103, 194, 58), 0.1);
	color: var(--im-color-success);
	font-size: 13px;

	i { font-size: 16px; }
}

.success-content {
	text-align: center;
	padding: 16px 0 8px;

	.success-icon {
		font-size: 48px;
		color: var(--im-color-success);
		margin-bottom: 12px;
	}

	h3 {
		font-size: 17px;
		margin-bottom: 6px;
		color: var(--im-text-color);
	}

	p {
		font-size: 13px;
		color: var(--im-text-color-light);
		line-height: 1.5;
		margin-bottom: 12px;
	}
}

.card-footer {
	padding-top: 12px;
	border-top: 1px solid rgba(var(--im-black-rgb), 0.06);
}

// 预览插图
.preview-card {
	gap: 10px;
}

.preview-step {
	display: flex;
	align-items: center;
	gap: 10px;

	&--pending { opacity: 0.4; }
}

.preview-step-num {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: var(--im-color-success, #67c23a);
	color: #fff;
	font-size: 12px;
	font-weight: 600;
	display: grid;
	place-items: center;
	flex-shrink: 0;

	&--active { background: var(--im-color-primary); }
	&--pending {
		background: var(--im-background-active);
		color: var(--im-text-color-light);
	}
}

.preview-step-body { flex: 1; min-width: 0; }

.preview-step-label {
	font-size: 13px;
	color: var(--im-text-color);
	font-weight: 500;
}

.preview-step-desc {
	font-size: 11px;
	color: var(--im-text-color-light);
	margin-top: 1px;
}

.preview-step-done {
	font-size: 14px;
	color: var(--im-color-success, #67c23a);
	flex-shrink: 0;
}

</style>
